<template>
  <div class="fadein">
    <div class="h30"></div>

    <div class="center1200 bg-white" style="position:relative;">
        <div class="h20"></div>
        <div class="center-title" >
          <span><img class="title-pic" src="/static/img/title-left.png" alt=""> 发布文章 <img class="title-pic" src="/static/img/title-right.png" alt=""></span>
          <el-breadcrumb separator="/" style="position:absolute;left:30px;top:30px;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/forum' }"
              >论坛</el-breadcrumb-item
            >
            <el-breadcrumb-item>发布文章</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- <div class="h20"></div> -->
        <div style="padding:20px;">
          <div v-if="get_user_info.level == null" style="text-align: center;">
            <span>登录后才能发布发布文章哈(￣▽￣")~</span><br><br>
            <div>
              <router-link to="/login">
              <el-button type="primary">请先登录</el-button>
              </router-link>
            </div>
          </div>
          <div v-else-if="get_user_info.level == 0" class="padding20">
            <span>在用户首次评论之前，需要填写一份简单的问卷，以达到活跃用户素质的目的；若用户没能完成我们设计的问题，则只能浏览和参与（投票），无法发表言论。我们希望为热爱电影的人群创建一片交流相处的净土，感谢配合 ヾ(o◕∀◕)ﾉ</span><br><br>
            <div style="text-align: center;">
                <el-button type="primary" @click="goTest()">GO~</el-button>
            </div>
          </div>
          
          <span v-else>

            标题：<el-input v-model="title" autocomplete="off" placeholder="标题" style="width:1110px;"  ></el-input>
            <div class="h20"></div>
            描述：<el-input v-model="desn" autocomplete="off" placeholder="描述" style="width:1110px;" ></el-input>
            
              <div class="h20"></div>
              <el-card style="height: 610px;">
                <quill-editor v-model="content" ref="myQuillEditor" style="height: 500px;" :options="editorOption">
                </quill-editor>
              </el-card>
              <div class="h20"></div>
              <div style="text-align:center;">
                <el-button type="primary" style="width:120px;" @click="createForum()">发 布</el-button>
  
              </div>
            </span>
        </div>

    </div>
    
    <div class="h30"></div>
    <Goback></Goback>

</div>
    
  </template>
  
  <script>
    import {
      quillEditor
    } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import Goback from '@/components/components/goback'

    export default {
      name: 'FuncFormsEdit',
      components: {
        Goback,
        quillEditor
      },
      data() {
        return {
          title:'',
          desn:'',
          content: null,
          editorOption: {},
          get_user_info:{
            level:null
          },
          loading:0,
        }
      },
      mounted(){
        this.getUserinfo();
      },
      methods:{
        getUserinfo(){
          if(localStorage.getItem('token')==null){
              return false;
          }
          $.ajax({
              url:"//"+ this.$API_URL +"/api/v1/user_info/"+localStorage.getItem('token'),
              type:"get",
              success:(ret)=>{
                  
                  this.get_user_info = ret.data
              }
          })
        },
        createForum(){
          if(this.title <=2){
            this.$message({
                showClose:true,
                message:"标题至少2个字呀~  Σ( ° △ °|||)︴ ",
                type:"error"
            })
            return false;
          }
          if(this.desn <=2){
            this.$message({
                showClose:true,
                message:"描述不能为空呀~  Σ( ° △ °|||)︴ ",
                type:"error"
            })
            return false;
          }
          if(this.content == null){
            this.$message({
                showClose:true,
                message:"内容不能为空呀~  Σ( ° △ °|||)︴ ",
                type:"error"
            })
            return false;
          }
          this.loading = 0
          this.openFullScreen()
          $.ajax({
            url:"//"+ this.$API_URL +"/api/v1/articles",
            type:"post",
            data:{title:this.title,content:this.content,desn:this.desn,author:localStorage.getItem('token')},
            success:(ret)=>{
              // 
              if(ret.code == 201){
                this.$message({
                  showClose:true,
                  message:"论坛发布成功 (*￣∇￣*)",
                  type:"success"
                })
                this.title = ''
                this.desn = ''
                this.content = ''
                this.$router.push('/forum').catch(err => {err});
                this.loading = 1
                this.openFullScreen()
              }else{
                this.$message({
                  showClose:true,
                  message:ret.msg,
                  type:"info"
                })
              }
                
            }
          })
        },
        goback(){
          // console.log(this.get_user_info)
          this.$router.go(-1);
        },
        //去Test页面
        goTest(){
          // console.log(document.location);
          this.$router.push('/test').catch(err => {err});
        },
        //页面加载中
        openFullScreen() {
          const loading = this.$loading({
          lock: true,
          text: "文章上传中（￣口￣）。。。",
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
          });
          // setTimeout(() => {
          if(this.loading==1){
            loading.close();
          }
          // }, 2000);
        },
      }
    }
  
  </script>
  
  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/components/index/createforum.vue